import Barba from 'barba.js'
import Animation from './Animation'
import Player from '@vimeo/player'

export default class PageLoader extends Animation {
    constructor() {
        super( false );

        this.element = document.querySelector('.loader');
        if( this.element ) this.build();
    }

    static key() {
        return 'loader';
    }

    build() {
        this.timeline
            .to( this.element.querySelector('.logo'), .5, { y: -50, opacity: 0} )
            .to( this.element.querySelector('.loading-indicator'), .5, { y: 50, opacity: 0} )
            .to( this.element, .25, { opacity: 0 }, .25 )
            .set( this.element , { display: 'none' });
    }

    onComplete() {
        document.querySelector('html').classList.remove('enable-loading');
        Barba.Dispatcher.trigger('pageLoading');
        this.element.remove();
    }

    play() {
        this.played = false;
        if( document.querySelector('.intro-content') ) {
            let container = document.querySelector('.intro-content');
            if( container.dataset.type === 'video' ) {
                const player = new Player( document.querySelector('#intro-video iframe') )
                player.on('play', () => {
                    this.played = true;
                    this.timeline.play();
                })
                setTimeout( () => {
                    if( ! this.played ) this.timeline.play()
                }, 2000)
            } else if( container.dataset.type === 'thumbnail' ) {
                this.timeline.play();
            }
        } else {
            this.timeline.play()
        }
    }
}